import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { BUSINESS } from "@/lib/site";

export const breadcrumbJsonLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: item.label,
    item: `${BUSINESS.siteUrl}${item.to}`,
  })),
});

export const Breadcrumb = ({ items }) => (
  <nav aria-label="Breadcrumb" data-testid="breadcrumb" className="text-sm">
    <ol className="flex flex-wrap items-center gap-1.5 text-body">
      {items.map((item, i) => {
        const last = i === items.length - 1;
        return (
          <li key={item.to} className="flex items-center gap-1.5">
            {last ? (
              <span aria-current="page" className="font-medium text-navy">
                {item.label}
              </span>
            ) : (
              <Link to={item.to} data-testid={`breadcrumb-link-${i}`} className="transition-colors hover:text-brand">
                {item.label}
              </Link>
            )}
            {!last && <ChevronRight size={14} aria-hidden="true" className="text-line" />}
          </li>
        );
      })}
    </ol>
  </nav>
);
